module.exports = __webpack_public_path__ + "img/close.92430ab3.svg";